/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetStreamUsagePathParams = NonNullable<operations['getStreamUsage']['parameters']['path']>;

export type GetStreamUsageQueryParams = NonNullable<operations['getStreamUsage']['parameters']['query']>;

export interface Input extends GetStreamUsagePathParams {
  apiVersion?: string;
  query?: GetStreamUsageQueryParams;
}

export async function getStreamUsage(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/usage/streams/{source}', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
